<template>
    <v-content>
        <v-app>
            <v-container grid-list-md text-xs-center>
                <v-layout align-center justify-center row>
                    <v-flex xs4>
                        <v-form ref="form" @submit="onSubmit" lazy-validation>
                            <v-text-field v-model="form.username" label="Username" :rules="[rules.required]" required></v-text-field>
                            <v-text-field v-model="form.password" :rules="[rules.required]" required :append-icon="show ? 'visibility_off' : 'visibility'"  :type="show ? 'text' : 'password'" name="input-10-1" label="Password" counter @click:append="show = !show"></v-text-field>
                            <v-btn type="submit" color="info">Login</v-btn>
                            
                        </v-form>
                    </v-flex>
                </v-layout>
                <v-layout align-center justify-center row>
                    <v-flex xs4 v-if='loginError'>
                        Incorrect login details.
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </v-content>
</template>

<script>
    import axios from 'axios';

    export default {
        data () {
            return {
                form: {
                    username: '',
                    password: ''
                },
                show: false,
                rules: {
                    required: v => !!v || 'Required.',
                }
            }
        },
        computed: {
            loginError() {
                return this.$store.state.error;
            }
        },
        methods: {
            onSubmit(e) {
                e.preventDefault();
                if (this.$refs.form.validate()) {
                    this.$store.dispatch('login', this.form);
                }
            }
        }
    }
</script>

<style>

</style>